import React, {Component} from "react";
import {setStatisticAppTypeFilter} from "../../../actions/actions/statistics";
import {connect} from "react-redux";
import moment from "moment";
import Select, {components} from "react-select";
import CheckBoxBtn from "../../common/Checkbox/CheckBoxBtn";
import __, {castArray, map} from "lodash";
import queryString from "query-string";
import {reactSelectStyles, urlFiltersParser, updateUrlFilter} from 'utils';
import _ from "i18n";

class StatisticAppTypeFilter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      checkedList: [],
      eventDivIsVisible: false,
      appList : ["registering", "cycle_registering", "packOrder"]
    };
  }

  handleDisplayCategorySelectItems = () => {
    this.setState(state => {
      return {
        eventDivIsVisible: !state.eventDivIsVisible
      };
    });
  };


  initFromFilter = () => {

    let defaultValue = this.state.checkedList;

    const urlParams   = queryString.parse(location.search);

    if(!urlParams.filters) {
      return defaultValue;
    }

    let filter = urlFiltersParser(urlParams.filters);
    if(!filter || filter.length <= 0) {
      return defaultValue;
    }

    let periodFilter = filter.filter(item => 'appType' === item.property);
    if(!periodFilter || periodFilter.length <= 0 || !periodFilter[0].value) {
      return defaultValue;
    }

    defaultValue = [];

    castArray(periodFilter[0].value).forEach(item => {
      defaultValue.push(item);
    });

    return defaultValue;
  };


  componentDidMount() {

    const filter = this.initFromFilter();
    const checkedList = __.uniq([...this.props.statisticsFilter.appType, ...filter]);

    updateUrlFilter('appType', 'in', checkedList);
    this.props.setStatisticAppTypeFilter(checkedList);

    this.setState({checkedList});
  }

  handleDeselectCategory = value => {
    let { statisticsFilter } = this.props;

    let newSelectedItems = [...statisticsFilter.appType];
    if (statisticsFilter.appType.includes(value)) {
      newSelectedItems.splice(newSelectedItems.indexOf(value), 1);
    } else {
      newSelectedItems.push(value);
    }
    updateUrlFilter('appType', 'in', newSelectedItems);
    this.props.setStatisticAppTypeFilter(newSelectedItems);
    this.setState({checkedList : newSelectedItems});

  };

  render() {

    const { eventDivIsVisible } = this.state;

    let checkedListeString = this.state.checkedList.map(x=> {
      return x.toString();
    });

    return (<div
        className={"customed_select ml-4" + " " + (this.state.eventDivIsVisible ? "customed_select_opened" : "customed_select_closed")
        }
      >
        <div
          className={
            "customed_select_header" +
            " " +
            (this.state.eventDivIsVisible
              ? "customed_select_header_down"
              : "customed_select_header_up")
          }
          onClick={this.handleDisplayCategorySelectItems}
        >
          <label className="text-left">{_("inscription-type")}</label>
        </div>

        {eventDivIsVisible && (
          <div className="customed_select_body">
            <div className="customed_select_body_label">
              {_("add-inscription")}
            </div>
            <div className="customed_select_body_items">

              {this.state.appList.map((item, index) => (
                <div className="customed_select_body_item1" key={index}>
                  <CheckBoxBtn
                    id={item}
                    checked={checkedListeString.includes(item+"")}
                    onChange={() => this.handleDeselectCategory(item+"")}
                  />
                  <div className="customed_select_body_item1_label">
                    {_(item)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter
});

const mapDispatchToProps = {
  setStatisticAppTypeFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticAppTypeFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/Statistics/StatisticAppTypeFilter.js